<template>
    <a-modal v-model="visible" :title="title" @cancel="closeModal" @ok="handleOk">
        <a-form-model :model="formData" :label-col="labelCol" :wrapper-col="wrapperCol">
            <template v-for="el of formList" >
                <a-form-model-item v-if="el.component === 'Input'" :label="el.label" :key="el.filed">
                    <a-input v-model="formData[el.filed]" />
                </a-form-model-item>
                <a-form-model-item v-if="el.component === 'Select'" :label="el.label" :key="el.filed">
                    <a-select v-model="formData[el.filed]" placeholder="请选择">
                        <a-select-option :value="it.value" v-for="it of el.data" :key="it.value">
                            {{ it.label }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item v-if="el.component === 'DatePicker'" :label="el.label" :key="el.filed">
                    <a-date-picker
                        v-model="formData[el.filed]"
                        :show-time="el.showTime"
                        type="date"
                        :placeholder="el.placeholder"
                        :valueFormat="el.valueFormat"
                        :format="el.format"
                        style="width: 100%;"
                    />
                </a-form-model-item>
                <a-form-model-item v-if="el.component === 'Switch'" :label="el.label" :key="el.filed">
                    <a-switch v-model="formData[el.filed]" />
                </a-form-model-item>
                <a-form-model-item v-if="el.component === 'CheckboxGroup'" :label="el.label" :key="el.filed">
                    <a-checkbox-group v-model="formData[el.filed]">
                        <a-checkbox :value="it.value" :name="it.label" v-for="it of el.data" :key="it.value">
                            {{ it.label }}
                        </a-checkbox>
                    </a-checkbox-group>
                </a-form-model-item>
                <a-form-model-item v-if="el.component === 'RadioGroup'" :label="el.label" :key="el.filed">
                    <a-radio-group v-model="formData[el.filed]" >
                        <a-radio :value="it.value" v-for="it of el.data" :key="it.value">
                            {{ it.label }}
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item v-if="el.component === 'Textarea'" :label="el.label" :key="el.filed">
                    <a-input v-model="formData[el.filed]" type="textarea" />
                </a-form-model-item>
            </template>
            
            
        </a-form-model>
    </a-modal>
</template>

<script>
export default {
    props:{
        // 表单列表
        formList:{
            type:Array,
            default:[]
        },
        // 表单数据
        formData:{
             type:Object,
            default:()=>({})
        },
        title:{
            type:String,
            default:''
        }
    },
    watch:{
        formData:{
            handler(el){

            },
            deep:true,
            immediate:true
        }
    },
    data(){
        return {
            visible:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        }
    },
    methods:{
        openModal(){
            this.visible = true
        },
        closeModal(){
            this.visible = false
            this.clearForm()
        },
        handleOk(){
            this.$emit('handleOk',this.formData)
            this.clearForm()
        },
        clearForm(){
            let obj = {...this.formData}
            Object.keys(obj).forEach(el=>{
                obj[el] = '' || null
            })
            Object.assign(this.formData,{...obj})
        },
        setProps(props){
            this.labelCol = props.labelCol
            this.wrapperCol = props.wrapperCol
        }
    }
}
</script>